export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND + "/api";
export const SITE = "Hverdagsmaden";
export const AUTHOR = "Redaktionen";
export const EMAIL = "din@email.dk";

export const store = {
  get(k, d) { try { const v = localStorage.getItem("ba_" + k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem("ba_" + k, JSON.stringify(v)); } catch (e) {} }
};
export const esc = s => String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
export const da = (n, d = 1) => n.toLocaleString("da-DK", { maximumFractionDigits: d });
export const FR = { 0.25: "¼", 0.5: "½", 0.75: "¾" };

export function num(n) {
  if (n >= 100) return String(Math.round(n / 5) * 5);
  if (n >= 10) return String(Math.round(n));
  const q = Math.round(n * 4) / 4, w = Math.floor(q), f = q - w;
  if (q === 0) return "";
  return (w ? String(w) : "") + (FR[f] || "");
}
export function amount(a, u) {
  if (u === "g" && a >= 1000) return da(a / 1000, 1) + " kg";
  if (u === "ml" && a >= 1000) return da(a / 1000, 1) + " l";
  if (u === "dl" && a >= 10) return da(a / 10, 1) + " l";
  const n = num(a);
  return n ? n + (u ? " " + u : "") : "en smule";
}
// build.py fmt_amt (used for JSON-LD)
export function fmtAmt(a) {
  if (a === null || a === undefined) return "";
  const w = Math.trunc(a), f = Math.round((a - w) * 100) / 100;
  if (f === 0) return String(w);
  if (FR[f]) return (w ? String(w) : "") + FR[f];
  return String(a).replace(".", ",");
}
export function toast(html, ms = 3200) {
  const old = document.querySelector(".toast"); if (old) old.remove();
  const t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); t.setAttribute("data-testid", "toast"); t.innerHTML = html;
  document.body.appendChild(t); setTimeout(() => t.remove(), ms);
}
export async function copy(text) {
  try { await navigator.clipboard.writeText(text); return true; }
  catch (e) {
    const ta = document.createElement("textarea"); ta.value = text; document.body.appendChild(ta); ta.select();
    let ok = false; try { ok = document.execCommand("copy"); } catch (e2) {} ta.remove(); return ok;
  }
}
export const imgSrc = r => (r.image_url ? BACKEND + r.image_url : null);
export const origin = () => process.env.REACT_APP_SITE_URL;
export const PLAN_URL = "/madplan/";

export function addToPlan(slug, n) {
  let p = store.get("plan", Array(7).fill("")); if (!Array.isArray(p) || p.length !== 7) p = Array(7).fill("");
  if (p.includes(slug)) { toast(`Allerede i din madplan. <a href="${PLAN_URL}">Åbn madplan</a>`); return; }
  const i = p.findIndex(x => !x);
  if (i < 0) { toast(`Madplanen er fuld. <a href="${PLAN_URL}">Åbn madplan</a>`); return; }
  p[i] = slug; store.set("plan", p); store.set("people", n);
  toast(`Tilføjet til madplanen. <a href="${PLAN_URL}">Åbn madplan</a>`);
}

export const TOOLS = [
  ["portionsberegner", "Portionsberegner", "⚖️", "Skaler din egen opskrift op eller ned til det antal personer, du skal lave mad til."],
  ["maengdeomregner", "Mængdeomregner", "🥄", "Omregn mellem dl, gram, spiseskefulde, teskefulde og kopper for mel, sukker, smør m.m."],
  ["airfryer-omregner", "Ovn til airfryer", "🍟", "Omregn temperatur og tid fra ovnopskrift til airfryer."],
  ["ovntemperatur", "Ovntemperatur", "🔥", "Omregn mellem varmluft, over-/undervarme, Fahrenheit og gas mark."],
  ["hvor-meget-pr-person", "Hvor meget pr. person?", "🍚", "Hvor mange gram pasta, ris, kød og kartofler skal I bruge? Beregn efter antal personer."],
  ["madbudget", "Madbudget-beregner", "💰", "Se, hvad I bruger på aftensmad, og hvor meget I kan spare."],
];
export const TBY = Object.fromEntries(TOOLS.map(t => [t[0], t]));

export const byPriceTime = (a, b) => a.price - b.price || a.time - b.time;
